import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import EditIcon from "@material-ui/icons/Edit";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { url } from "../../../../../Config/Config";
import Axios from "axios";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import { useStyles } from "../../../../../Components/CSS/DetailStyle.css";
import { formatTime } from "../../../../../Components/FormatTime/FormatTime";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class ExamConfigDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      examConfigDetail: [],
      subjects: [],
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getExamConfig(this.props.match.params.id);
    }
  }

  getExamConfig = async (examConfigId) => {
    try {
      const response = await Axios.get(`${url}/api/exams/${examConfigId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.exam.length !== 0) {
        this.setState({
          examConfigDetail: response.data.exam,
          subjects: response.data.exam.subjects,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getExamConfig(examConfigId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { examConfigDetail, subjects } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <PageTitle
            title="Exam Configuration Info"
            url={`/administration/examconfig/edit/${this.props.match.params.id}`}
            urlTitle="Edit Exam Config"
            icon={<EditIcon style={{ color: "#1f1f1f" }} />}
          />
          {examConfigDetail.length1 !== 0 && (
            <div>
              <div
                style={{ width: "100%", display: "flex", flexDirection: "row" }}
              >
                <div style={{ width: "50%" }}>
                  <ListItem divider>
                    <div style={{ fontWeight: "bold", flexGrow: 1 }}>
                      Exam Type
                    </div>
                    <div>{examConfigDetail.examType}</div>
                  </ListItem>
                  <ListItem divider>
                    <div style={{ fontWeight: "bold", flexGrow: 1 }}>
                      Class Name
                    </div>
                    <div>{examConfigDetail.className}</div>
                  </ListItem>
                  <ListItem divider>
                    <div style={{ fontWeight: "bold", flexGrow: 1 }}>Group</div>
                    <div>
                      {examConfigDetail.group ? examConfigDetail.group : "N/A"}
                    </div>
                  </ListItem>
                </div>
                <div style={{ width: "50%" }}>
                  <ListItem divider>
                    <div style={{ fontWeight: "bold", flexGrow: 1 }}>
                      Session
                    </div>
                    <div>{examConfigDetail.session}</div>
                  </ListItem>
                  <ListItem divider>
                    <div style={{ fontWeight: "bold", flexGrow: 1 }}>
                      Faculty
                    </div>
                    <div>
                      {examConfigDetail.faculty
                        ? examConfigDetail.faculty
                        : "N/A"}
                    </div>
                  </ListItem>
                  <ListItem divider>
                    <div style={{ fontWeight: "bold", flexGrow: 1 }}>
                      Section
                    </div>
                    <div>{examConfigDetail.section}</div>
                  </ListItem>
                </div>
              </div>
              {subjects.length !== 0 && (
                <div>
                  <ListItem style={{ fontWeight: "bold" }}>
                    Subjects TimeTable
                  </ListItem>
                  <ListItem
                    divider
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <b style={{ width: "25%", textAlign: "center" }}>
                      Subject Name
                    </b>
                    <b style={{ width: "25%", textAlign: "center" }}>
                      Exam Date
                    </b>
                    <b style={{ width: "25%", textAlign: "center" }}>
                      Start Time
                    </b>
                    <b style={{ width: "25%", textAlign: "center" }}>
                      End Time
                    </b>
                  </ListItem>
                  {subjects.map((subject, index) => (
                    <div key={index}>
                      <ListItem
                        divider
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div style={{ width: "25%", textAlign: "center" }}>
                          {subject.name}
                        </div>
                        <div style={{ width: "25%", textAlign: "center" }}>
                          {subject.date}
                        </div>
                        <div style={{ width: "25%", textAlign: "center" }}>
                          {formatTime(subject.startTime)}
                        </div>
                        <div style={{ width: "25%", textAlign: "center" }}>
                          {formatTime(subject.endTime)}
                        </div>
                      </ListItem>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ExamConfigDetails)));
